import { render } from "./NextWeek.vue?vue&type=template&id=228603aa&scoped=true"
import script from "./NextWeek.vue?vue&type=script&lang=js"
export * from "./NextWeek.vue?vue&type=script&lang=js"

import "./NextWeek.vue?vue&type=style&index=0&id=228603aa&scoped=true&lang=scss"
script.render = render
script.__scopeId = "data-v-228603aa"

export default script